import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Deepfake'

export const GET_DEEPFAKE_PROFILES_ASYNC = createAsyncTypes('GET_DEEPFAKE_PROFILES', typeKey)
export const CREATE_DEEPFAKE_PROFILE_ASYNC = createAsyncTypes('CREATE_DEEPFAKE_PROFILE', typeKey)
export const CREATE_DEEPFAKE_PROFILES_BULK_ASYNC = createAsyncTypes(
  'CREATE_DEEPFAKE_PROFILES_BULK',
  typeKey
)
export const UPDATE_DEEPFAKE_PROFILE_ASYNC = createAsyncTypes('UPDATE_DEEPFAKE_PROFILE', typeKey)
export const DELETE_DEEPFAKE_PROFILE_ASYNC = createAsyncTypes('DELETE_DEEPFAKE_PROFILE', typeKey)
export const GET_DEEPFAKE_MAILBOX_LIST_ASYNC = createAsyncTypes(
  'GET_DEEPFAKE_MAILBOX_LIST',
  typeKey
)
export const GET_DEEPFAKE_ALL_USERS_ASYNC = createAsyncTypes('GET_DEEPFAKE_ALL_USERS', typeKey)
export const GET_DEEPFAKE_NON_DELETED_IDS_ASYNC = createAsyncTypes(
  'GET_DEEPFAKE_NON_DELETED_IDS',
  typeKey
)
export const GET_DEEPFAKE_AD_GROUPS_ASYNC = createAsyncTypes('GET_DEEPFAKE_AD_GROUPS', typeKey)
export const GET_DEEPFAKE_AD_GROUPS_USER_COUNT_ASYNC = createAsyncTypes(
  'GET_DEEPFAKE_AD_GROUPS_USER_COUNT',
  typeKey
)
export const GET_DEEPFAKE_KEY_PERSON_AD_GROUPS_ASYNC = createAsyncTypes(
  'GET_DEEPFAKE_KEY_PERSON_AD_GROUPS',
  typeKey
)
export const CREATE_DEEPFAKE_KEY_PERSON_AD_GROUPS_ASYNC = createAsyncTypes(
  'CREATE_DEEPFAKE_KEY_PERSON_AD_GROUPS',
  typeKey
)
export const DELETE_DEEPFAKE_KEY_PERSON_AD_GROUP_ASYNC = createAsyncTypes(
  'DELETE_DEEPFAKE_KEY_PERSON_AD_GROUP',
  typeKey
)

export const SET_DEEPFAKE_MAILBOX_LIST_PAGE = `${typeKey}/SET_DEEPFAKE_MAILBOX_LIST_PAGE`
export const SET_DEEPFAKE_MAILBOX_LIST_VALUE = `${typeKey}/SET_DEEPFAKE_MAILBOX_LIST_VALUE`
export const SET_EMPLOYEE_INFO = `${typeKey}/SET_EMPLOYEE_INFO`
export const SET_EMPLOYEE_INFO_FIELD = `${typeKey}/SET_EMPLOYEE_INFO_FIELD`
export const SET_DEEPFAKE_FILTERS = 'SET_DEEPFAKE_FILTERS'
export const CLEAR_DEEPFAKE_FILTERS = 'CLEAR_DEEPFAKE_FILTERS'
export const SET_DEEPFAKE_PROFILES_PAGE = `${typeKey}/SET_DEEPFAKE_PROFILES_PAGE`
export const SET_DEEPFAKE_PROFILES_PAGE_SIZE = `${typeKey}/SET_DEEPFAKE_PROFILES_PAGE_SIZE`
export const SET_DEEPFAKE_PROFILES_ORDERING = `${typeKey}/SET_DEEPFAKE_PROFILES_ORDERING`

export const MAILBOXES_PER_PAGE = 20
